import MiniCalendar from 'components/calendar/MiniCalendar'
import DefaultDay from './components/DefaultDay'

const days = {
  '2025_258': { categories: '🚀🐞', section: '20.4.2', exclusiveInstitutions: [] },
  '2025_259': { categories: '🚀', section: '20.4.3', exclusiveInstitutions: ['agsus'] },
  '2025_272': { categories: '🚀🛠️🐞', section: '20.5.0', exclusiveInstitutions: [] },
  '2025_273': { categories: '🚀🛠️🐞', section: '20.6.0', exclusiveInstitutions: [] },
  '2025_275': { categories: '🚀🛠️🐞', section: '20.7.0', exclusiveInstitutions: [] },
  '2025_276': { categories: '🚀🛠️🐞', section: '20.8.0', exclusiveInstitutions: [] },
  '2025_281': { categories: '🚀🛠️', section: '20.9.0', exclusiveInstitutions: [] },
  '2025_283': { categories: '🛠️🐞', section: '20.10.0', exclusiveInstitutions: [] },
  '2025_286': { categories: '🚀🐞', section: '20.11.0', exclusiveInstitutions: [] },
  '2025_287': { categories: '🚀🐞', section: '20.12.0', exclusiveInstitutions: [] },
  '2025_289': { categories: '📣🚀🛠️🐞', section: '20.13.0', exclusiveInstitutions: [] },
  '2025_294': { categories: '📣🛠️', section: '20.14.0', exclusiveInstitutions: [] },
  '2025_297': { categories: '🚀🛠️', section: '20.15.0', exclusiveInstitutions: [] },
  '2025_301': { categories: '🚀🛠️🐞', section: '20.16.0', exclusiveInstitutions: [] },
  '2025_308': { categories: '🚀🛠️', section: '20.17.0', exclusiveInstitutions: [] },
  '2025_309': { categories: '🚀🛠️🐞', section: '20.18.0', exclusiveInstitutions: [] },
  '2025_310': { categories: '🚀🛠️🐞', section: '20.19.0', exclusiveInstitutions: [] },
  '2025_315': { categories: '🚀🛠️🐞', section: '20.20.1', exclusiveInstitutions: [] },
  '2025_316': { categories: '🐞', section: '20.20.3', exclusiveInstitutions: [] },
  '2025_317': { categories: '🚀🛠️🐞', section: '20.21.0', exclusiveInstitutions: [] },
}

export default function CustomCalendar() {
  return <MiniCalendar DayOfTheMonthComponent={DefaultDay} dataOfTheDays={days} />
}
